export default (function (_ref) {
  var request = _ref.request;
  return {
    smartControlCmdAdd: function smartControlCmdAdd(data) {
      return request({
        url: '/iot/smartControlCmd/add',
        method: 'post',
        data: data
      });
    },
    smartControlCmdModify: function smartControlCmdModify(data) {
      return request({
        url: "/iot/smartControlCmd/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    smartControlCmdExecute: function smartControlCmdExecute(id) {
      return request({
        url: "/iot/smartControlCmd/".concat(id, "/execute"),
        method: 'post'
      });
    },
    smartControlCmdDel: function smartControlCmdDel(id) {
      return request({
        url: "/iot/smartControlCmd/".concat(id, "/del"),
        method: 'delete'
      });
    },
    smartControlCmdQuery: function smartControlCmdQuery(data) {
      return request({
        url: '/iot/smartControlCmd/query',
        method: 'get',
        params: data
      });
    },
    smartControlCmdDetail: function smartControlCmdDetail(id) {
      return request({
        url: "/iot/smartControlCmd/".concat(id, "/detail"),
        method: 'get'
      });
    },
    smartControlCmdManagerList: function smartControlCmdManagerList(controlId) {
      return request({
        url: "/iot/smartControlCmd/".concat(controlId, "/managerList"),
        method: 'get'
      });
    }
  };
});